import CONSTANT from '../constant';
import { getVersion, getBuildVersion } from '../util/env';

class ConfigUtil {
    constructor () {
        this.config = {
            /* sdk 定制相关，开始 */
            showHeader: false,
            // 是否显示版权标志
            showCopyrightLogo: false,
            // 是否开启从云端加载插件，只为 Makeblock 官方服务
            enableRemoteExts: false,
            // 系统使用的默认资源列表开关
            defaultAssets: {
                'scratch': true, // scratch 官方的资源
                'makeblock': true, // makeblock 的资源
                'customize': false // 是否开启自定义的资源，默认为 false
            },
            // 远程的资源地址
            remoteAssetsUrls: {
                sprite: null, // 示例： http://a.com/xxx.json
                costume: null,
                backdrop: null,
                sound: null
            },
            /* sdk 定制相关，结束 */
            appVersion: getVersion(),
            version: getBuildVersion(),
            enableDevice: true,
            excludeDevices: ['microbit'],
            spriteBasepath: 'static/resource/scratch/',
            userSpriteBasepath: 'static/resource/scratch/',
            userSpriteFilePath: 'static/sprites/',
            userSpriteFileName: 'sprite.json',
            spriteCustom: {
                [CONSTANT.SPRITE_TYPE.USER_LIBS]: 'sprite.json',
                [CONSTANT.SPRITE_TYPE.USER_COSTUMES]: 'costume.json',
                [CONSTANT.SPRITE_TYPE.USER_BACKDROPS]: 'backdrop.json',
                [CONSTANT.SPRITE_TYPE.USER_SOUNDS]: 'sound.json'
            },
            userProjectFilePath: 'static/projects/',
            userProjectFileName: 'project.json',
            userCoverImageFilePath: 'static/coverImages/',
            downloadDriverBtn: {
                'text': '',
                'handler': () => {}
            },
            appRootPath: './'
        };
        this.init();
    }

    init () {
        if (!IS_BUILD_TEST && !IS_BUILD_PRODUCTION) {
            this.config.domain = require('./dev/domain.json');
            this.config.link = require('./dev/link.json');
            this.config.socket = require('./dev/socket.json');
            this.config.social = require('./dev/social.json');
        }

        if (IS_BUILD_TEST) {
            this.config.domain = require('./test/domain.json');
            this.config.link = require('./test/link.json');
            this.config.socket = require('./test/socket.json');
            this.config.social = require('./test/social.json');
        }

        if (IS_BUILD_PRODUCTION) {
            this.config.domain = require('./production/domain.json');
            this.config.link = require('./production/link.json');
            this.config.socket = require('./production/socket.json');
            this.config.social = require('./production/social.json');
        }
    }

    setConfig(optConfig) {
        this.config = Object.assign(this.config, optConfig);
    }
}
let configUtil = new ConfigUtil();
let config = configUtil.config;
window.config = config;

export {
    config as default,
    configUtil
};